import {
    MiniKit,
    Permission,
    RequestPermissionErrorCodes,
    RequestPermissionPayload,
} from '@worldcoin/minikit-js';
import { t } from 'i18next';
import React, { Suspense, useEffect } from 'react';
import { Navigate, Route, Routes } from 'react-router';
import Feed from './pages/feed';
import Future from './pages/future';
import Orders from './pages/orders';
import { RootLayout } from './pages/root-layout';
import TradingChallenge from './pages/TradingChallenge';
import { useAutoLogin } from './store/auth';

// const Earn = React.lazy(() => import('./pages/earn'));
const Market = React.lazy(() => import('./pages/market'));
const HomePage = React.lazy(() => import('./pages/home'));

const requestPermission = async () => {
    if (!MiniKit.isInstalled()) {
        return;
    }
    const requestPermissionPayload: RequestPermissionPayload = {
        permission: Permission.Notifications,
    };
    const payload = await MiniKit.commandsAsync.requestPermission(
        requestPermissionPayload
    );
    if (payload.finalPayload.status === 'error') {
        switch (payload.finalPayload.error_code) {
            case RequestPermissionErrorCodes.AlreadyGranted: {
                return;
            }
            case RequestPermissionErrorCodes.GenericError:
                return;
            case RequestPermissionErrorCodes.PermissionDisabled:
            case RequestPermissionErrorCodes.UserRejected:
                // setOpen(true);

                // setting https://worldcoin.org/settings/miniapps
                return;
            default:
                break;
        }
    }
};

function App() {
    useAutoLogin();
   
    useEffect(() => {
        setTimeout(() => {
            requestPermission();
        }, 3000);
    }, []);

    return (
        <Suspense fallback={<p>{t('Loading')}...</p>}>
            <Routes>
                <Route element={<RootLayout />} path="/">
                    <Route index element={<Navigate to="/market" replace />} />
                    <Route path="/future" element={<Future />} />

                    <Route path="/market" element={<Market />} />
                    <Route path="/portfolio" element={<HomePage />} />
                    {/* <Route path="/earn" element={<Earn />} /> */}
                    <Route path="/orders" element={<Orders />} />
                    <Route path="/feed" element={<Feed />} />

                    <Route
                        path="*"
                        element={<Navigate to={'/market'} replace />}
                    />
                </Route>

                <Route
                    path="/trading-challenge"
                    element={<TradingChallenge />}
                />
            </Routes>
        </Suspense>
    );
}

export default App;
